'use client';
import { formatDate } from '@/utilities';
import { usePathname } from 'next/navigation';
import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';
import OfferBox from './OfferBox';
import SocialBar from './SocialBar';

const ResourceHero = ({
    modified,
    title, 
    heroImage, 
    blogPromo, 
    colorScheme, 
    author, 
    publishDate, 
    metaFull = false 
}) => {
    const pathName = usePathname();
    const defaultAuthor = pathName?.includes('news') ? 'Anna Klement' : 'Raveena Arora';
    const authorName = author || defaultAuthor;
    const renderImage = () => {
        const { mediaItemUrl, mediaDetails, altText } = heroImage?.node || {};
        return (
            <div className={styles.resourceHero__image}>
                <Image 
                    src={mediaItemUrl || '/resourse_backup_hero.jpeg'} 
                    width={mediaDetails?.width || 2000} 
                    height={mediaDetails?.height || 800} 
                    alt={altText || title} 
                />
            </div>
        )
    };

    const determineTagText = (path) => {
        if (path.includes('webinar')) return 'Webinar';
        if (path.includes('success')) return 'Success Story';
        if (path.includes('insight')) return 'Industry Insights';
        if (path.includes('news')) return 'Company News';
        return 'Blog';
    };

    const renderTag = () => (
        <div className={styles.resourceHero__tags}>
            <Link className={`${styles.resourceHero__tag} tag`} href="#">
                {determineTagText(pathName)}
            </Link>
        </div>
    );
    return (
        <section className={`${styles.resourceHero} ${!heroImage?.node?.mediaDetails ? 'no_hero' : ''}`}>
            <div className='container'>
                <div className={`${styles.resourceHero__inner}  ${colorScheme?.[0]}`}>
                    {renderImage()}
                    <div className={`
                        ${styles.resourceHero__content} 
                        ${(colorScheme && colorScheme[0] === "champion") ? 'random-grid-dark-fade-top-center' : 'random-grid-light-fade-top-center'}
                        ${!heroImage?.node?.mediaDetails ? 'no_hero_content' : ''}
                        `}>
                        <div className="container">
                            <div className={styles.resourceHero__contentInner}>
                                <div className={`${styles.resourceHero__meta} ${metaFull ? styles.resourceHero__metaFull: ''}`}>
                                    <h1 className={`${styles.resourceHero__title} ${colorScheme?.[0]}`}>
                                        {title}
                                    </h1>
                                    {renderTag()}
                                    <div className={`${styles.resourceHero__attribution} ${colorScheme?.[0]}`}>
                                        By {authorName}
                                    </div>
                                    <div className={`${styles.resourceHero__attribution} ${colorScheme?.[0]}`}>
                                        {publishDate ?  `Published On  ${formatDate(publishDate)}` : ``}
                                    </div>
                                    {modified && (
                                        <div className={`${styles.resourceHero__attribution} ${colorScheme?.[0]}`}>
                                            Updated On {formatDate(modified)}
                                        </div>
                                    )}
                                    <SocialBar colorScheme={colorScheme} title={title}/>
                                </div>
                                {blogPromo?.promoCopy && <OfferBox {...blogPromo} colorScheme={colorScheme} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ResourceHero;
